/* Pure Desi — Round 6 motion companion (2026-07-24).
   Scroll reveals (homepage only) + trust-icon draw trigger + cart-count pop.
   Bails out entirely under prefers-reduced-motion. If this file never runs,
   no element is ever hidden (CSS gates all hidden states behind .pd-motion). */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var run = function () {
    var root = document.documentElement;

    /* Homepage scroll reveals + trust-strip draw trigger */
    try {
      if (document.body.classList.contains('template-index') && 'IntersectionObserver' in window) {
        var targets = [];
        /* Observe every .section-heading — the CSS hides all of them under
           .pd-motion, so every one must be observed to be revealed. */
        document.querySelectorAll('.section-heading').forEach(function (el) {
          targets.push(el);
        });
        var strip = document.querySelector('.pd-trust-strip');
        if (strip) targets.push(strip);
        /* Best Sellers: observe the SECTION, not the cards — the theme's slider
           recreates card nodes, so per-item observation misses. CSS handles the
           per-card stagger once the section gets .pd-in. */
        var bestSellers = document.querySelector('[id^="shopify-section"][id$="__featured-collection"]');
        if (bestSellers) targets.push(bestSellers);
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('pd-in');
            io.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.15 });
        /* Hidden states activate only once the observer exists */
        root.classList.add('pd-motion');
        targets.forEach(function (el) { io.observe(el); });
      }
    } catch (e) {
      root.classList.remove('pd-motion');
    }

    /* Cart-count pop on change (all pages) */
    try {
      document.querySelectorAll('.cart__count').forEach(function (el) {
        var observer = new MutationObserver(function () {
          el.classList.remove('pd-pop');
          void el.offsetWidth;
          el.classList.add('pd-pop');
        });
        observer.observe(el, { childList: true, characterData: true, subtree: true });
      });
    } catch (e) { /* non-critical */ }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
